export default __webpack_public_path__ + "static/media/fphoto3.3a15f24a.jpeg";